import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import MultipleCostInvoiceRow from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceRow'
import GHref from 'tennders-market/common/components/element/GHref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

const MultipleCostInvoiceLines = (props) => {
  const {
    lines,
    errors,
    removeLine,
    form,
    onFormChange,
    addNewLine,
    selectedTransaction,
    selectedPaymentTerm
  } = props
  const { t } = useTranslation()

  return (
    <>
      <p className="text-uppercase mb-10 ls-1">
        <strong>{t('costInvoice:orders')}</strong>
      </p>
      <div className="w-100">
        <table
          className="tennders-table-zebra"
          style={{ minWidth: 900 }}
        >
          <thead>
            <tr>
              <th />
              <th>#</th>
              <th>{t('costInvoice:tagOrderIds')}</th>
              <th>{t('costInvoice:agreedPrice')}</th>
              <th>{t('costInvoice:agreedPT')}</th>
              <th>{t('costInvoice:amountOnInvoice')}</th>
              <th>{t('costInvoice:vatPercentage')}</th>
              <th>{t('costInvoice:concept')}</th>
              <th>{t('costInvoice:difference')}</th>
              <th>{t('costInvoice:tbp')}</th>
              <th>{t('costInvoice:cmr')}</th>
              <th>{t('costInvoice:isSalesInvoiced')}</th>
              <th>{t('costInvoice:salesInvoiceId')}</th>
            </tr>
          </thead>
          <tbody>
            {lines.map((line, i) => (
              <MultipleCostInvoiceRow
                initialErrors={errors[i]}
                lineCount={lines?.length}
                errors={errors}
                selectedTransaction={selectedTransaction}
                index={i}
                key={line.id}
                keyIndex={line.id}
                saved={line?.saved}
                defaultVatPercentage={form?.defaultVat}
                reversedVat={form?.reversedVat}
                removeLine={removeLine}
                onFormChange={onFormChange}
                companyId={form.company}
                selectedPaymentTerm={selectedPaymentTerm}
              />
            ))}
          </tbody>
        </table>
      </div>
      <GHref className="btn-border small standard-btn mt-16" onClick={() => addNewLine()}>
        <span className="mr-6">
          <FontAwesomeIcon icon={faPlus} />
        </span>
        {t('multiple_cost_invoice:add_order')}
      </GHref>
    </>
  )
}

export default React.memo(MultipleCostInvoiceLines)
